// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DeleteWorkbookParameterSetsMutationVariables = Types.Exact<{
  workbookId: Types.Scalars["ID"]["input"];
  parameterSetId: Types.Scalars["ID"]["input"];
}>;

export type DeleteWorkbookParameterSetsMutation = {
  __typename?: "Mutation";
  deleteWorkbookParameterSets?: {
    __typename?: "Workbook";
    id: string;
    parameterRefAliases: Array<string>;
    parameterSets: Array<{
      __typename?: "WorkbookParameterSet";
      id: string;
      name: string;
      paramValues: any;
    }>;
    aliasParamMapList: Array<{
      __typename?: "AliasParamMap";
      id: string;
      name: string;
      parameters: any;
    }>;
  } | null;
};

export const DeleteWorkbookParameterSetsDocument = gql`
  mutation DeleteWorkbookParameterSets($workbookId: ID!, $parameterSetId: ID!) {
    deleteWorkbookParameterSets(
      workbookId: $workbookId
      parameterSetId: $parameterSetId
    ) {
      id
      parameterSets {
        id
        name
        paramValues
      }
      parameterRefAliases
      aliasParamMapList {
        id
        name
        parameters
      }
    }
  }
`;
export type DeleteWorkbookParameterSetsMutationFn = Apollo.MutationFunction<
  DeleteWorkbookParameterSetsMutation,
  DeleteWorkbookParameterSetsMutationVariables
>;

/**
 * __useDeleteWorkbookParameterSetsMutation__
 *
 * To run a mutation, you first call `useDeleteWorkbookParameterSetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkbookParameterSetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkbookParameterSetsMutation, { data, loading, error }] = useDeleteWorkbookParameterSetsMutation({
 *   variables: {
 *      workbookId: // value for 'workbookId'
 *      parameterSetId: // value for 'parameterSetId'
 *   },
 * });
 */
export function useDeleteWorkbookParameterSetsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWorkbookParameterSetsMutation,
    DeleteWorkbookParameterSetsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteWorkbookParameterSetsMutation,
    DeleteWorkbookParameterSetsMutationVariables
  >(DeleteWorkbookParameterSetsDocument, options);
}
export type DeleteWorkbookParameterSetsMutationHookResult = ReturnType<
  typeof useDeleteWorkbookParameterSetsMutation
>;
export type DeleteWorkbookParameterSetsMutationResult =
  Apollo.MutationResult<DeleteWorkbookParameterSetsMutation>;
export type DeleteWorkbookParameterSetsMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteWorkbookParameterSetsMutation,
    DeleteWorkbookParameterSetsMutationVariables
  >;
